import { ListItemAvatar } from "@material-ui/core";

export default ListItemAvatar;
